export default "__VITE_ASSET__DSI4nOid__"